
const UserList = () => import(/* webpackChunkName: "admin" */ '@/views/User/UserList')
const UserInfo = () => import(/* webpackChunkName: "admin" */ '@/views/User/UserInfo')
const UserCreate = () => import(/* webpackChunkName: "admin" */ '@/views/User/UserCreate')

const TeamList = () => import(/* webpackChunkName: "admin" */ '@/views/User/TeamList')
const TeamCreate = () => import(/* webpackChunkName: "admin" */ '@/views/User/TeamCreate')
const TeamUpdate = () => import(/* webpackChunkName: "admin" */ '@/views/User/TeamUpdate')
const TeamMemberList = () => import(/* webpackChunkName: "admin" */ '@/views/User/TeamMemberList')
const TeamMemberCreate = () => import(/* webpackChunkName: "admin" */ '@/views/User/TeamMemberCreate')
const TeamMemberUpdate = () => import(/* webpackChunkName: "admin" */ '@/views/User/TeamMemberUpdate')

const TeamSurveyQuestionList = () => import(/* webpackChunkName: "admin" */ '@/views/User/TeamSurveyQuestionList')
const TeamSurveyQuestionCreate = () => import(/* webpackChunkName: "admin" */ '@/views/User/TeamSurveyQuestionCreate')

const TeamSurveyResultList = () => import(/* webpackChunkName: "admin" */ '@/views/User/TeamSurveyResultList')

const HolidayList = () => import(/* webpackChunkName: "admin" */ '@/views/Admin/HolidayList')
const HolidayCreate = () => import(/* webpackChunkName: "admin" */ '@/views/Admin/HolidayCreate')

const teamTitle = process.env.VUE_APP_TEAM_NAME
const teamsTitle = `${teamTitle}s`
const teamPath = process.env.VUE_APP_TEAM_PATH

export default [
  {
    path: teamPath,
    name: 'team_list',
    component: TeamList,
    meta: {
      title: teamsTitle,
      crumbs: [{ title: teamsTitle }],
    },
  },
  {
    path: `${teamPath}/create`,
    name: 'team_create',
    component: TeamCreate,
    meta: {
      title: `Create ${teamTitle}`,
      crumbs: [
        { route: 'team_list', title: teamsTitle },
        { title: 'Create' },
      ],
    },
  },
  {
    path: `${teamPath}/:id/update`,
    name: 'team_update',
    props: true,
    component: TeamUpdate,
    meta: {
      title: `Update ${teamTitle}`,
      crumbs: [
        { route: 'team_list', title: teamsTitle },
        { getter: 'user/teamName' },
      ],
    },
  },
  {
    path: `${teamPath}/:teamId/members`,
    name: 'team_member_list',
    props: true,
    component: TeamMemberList,
    meta: {
      title: `${teamTitle} Members`,
      crumbs: [
        { route: 'team_list', title: teamsTitle },
        { getter: 'user/teamName' },
      ],
    },
  },
  {
    path: `${teamPath}/:teamId/members/create`,
    name: 'team_member_create',
    props: true,
    component: TeamMemberCreate,
    meta: {
      title: `Add ${teamTitle} Member`,
      crumbs: [
        { route: 'team_list', title: teamsTitle },
        { getter: 'user/teamName' },
        { title: 'Add Member' },
      ],
    },
  },
  {
    path: `${teamPath}/:teamId/members/:id/update`,
    name: 'team_member_update',
    props: true,
    component: TeamMemberUpdate,
    meta: {
      title: `Update ${teamTitle} Member`,
      crumbs: [
        { route: 'team_list', title: teamsTitle },
        { getter: 'user/teamName' },
        { title: 'Update Member' },
      ],
    },
  },
  {
    path: `${teamPath}/:teamId/survey_questions`,
    name: 'team_survey_question_list',
    props: true,
    component: TeamSurveyQuestionList,
    meta: {
      crumbs: [
        { route: 'team_list', title: teamsTitle },
        { getter: 'user/teamName' },
      ],
    },
  },
  {
    path: `${teamPath}/:teamId/survey_questions/create`,
    name: 'team_survey_question_create',
    props: true,
    component: TeamSurveyQuestionCreate,
    meta: {
      crumbs: [
        { route: 'team_list', title: teamsTitle },
        { getter: 'user/teamName' },
        { title: 'Create Question' },
      ],
    },
  },
  {
    path: `${teamPath}/:teamId/survey_questions/:id/update`,
    name: 'team_survey_question_update',
    props: true,
    component: TeamSurveyQuestionCreate,
    meta: {
      crumbs: [
        { route: 'team_list', title: teamsTitle },
        { getter: 'user/teamName' },
        { title: 'Update Question' },
      ],
    },
  },
  {
    path: `${teamPath}/:teamId/survey_results`,
    name: 'team_survey_result_list',
    props: true,
    component: TeamSurveyResultList,
    meta: {
      crumbs: [
        { route: 'team_list', title: teamsTitle },
        { getter: 'user/teamName' },
      ],
    },
  },
  {
    path: 'users',
    name: 'user_list',
    component: UserList,
    meta: {
      title: 'Users',
      crumbs: [{ title: 'Users' }],
    },
  },
  {
    path: 'users/create',
    name: 'user_create',
    component: UserCreate,
    meta: {
      crumbs: [
        { route: 'user_list', title: 'Users' },
        { title: 'Create' },
      ],
    },
  },
  {
    path: 'users/:id',
    name: 'user_info',
    props: true,
    component: UserInfo,
    meta: {
      crumbs: [
        { route: 'user_list', title: 'Users' },
        { route: 'user_info', getter: 'user/userName' },
      ],
    },
  },
  {
    path: 'users/:id/update',
    name: 'user_update',
    props: true,
    component: UserCreate,
    meta: {
      crumbs: [
        { route: 'user_list', title: 'Users' },
        { route: 'user_info', getter: 'user/userName' },
        { title: 'Update' },
      ],
    },
  },
  {
    path: 'holidays',
    name: 'holiday_list',
    component: HolidayList,
    meta: {
      title: 'Holidays',
      crumbs: [{ title: 'Holidays' }],
    },
  },
  {
    path: 'holidays/create',
    name: 'holiday_create',
    component: HolidayCreate,
    meta: {
      crumbs: [
        { route: 'holiday_list', title: 'Holidays' },
        { title: 'Create' },
      ],
    },
  },
  {
    path: 'holidays/:id/update',
    name: 'holiday_update',
    props: true,
    component: HolidayCreate,
    meta: {
      crumbs: [
        { route: 'holiday_list', title: 'Holidays' },
        { title: 'Update' },
      ],
    },
  },
]
